var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProperty1Enviadotecnica(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM7.28407 16.8868C7.47346 17.0147 7.67336 17.0342 7.88379 16.9454L17.6055 12.6161C17.8685 12.494 18 12.2887 18 12.0001C18 11.7114 17.8685 11.5061 17.6055 11.384L7.88379 7.05471C7.67336 6.9659 7.47346 6.98522 7.28407 7.11265C7.09469 7.24053 7 7.42658 7 7.67079V10.1518C7 10.3072 7.04209 10.446 7.12626 10.5681C7.21043 10.6902 7.32616 10.7679 7.47346 10.8012L12.0502 12.0001L7.47346 13.1989C7.32616 13.2322 7.21043 13.3099 7.12626 13.432C7.04209 13.5541 7 13.6929 7 13.8483V16.3293C7 16.5735 7.09469 16.7594 7.28407 16.8868Z",
    fill: "#375EA8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty1Enviadotecnica);
export default __webpack_public_path__ + "static/media/Property 1=enviado tecnica.b2953ed4135ab6649b65d01c9a668d90.svg";
export { ForwardRef as ReactComponent };